import { Button, Card, Modal, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';

import { AddOrderModal } from './components/AddOrderModal';
import { Filters } from './components/Filters';
import { NoteDrawer } from './components/NoteDrawer';
import { DUMMY_ORDER_LIST } from './constants';
import { getOrderTableColumns } from './helpers';
import styles from './index.module.scss';

const { confirm } = Modal;

export const OrderManagement = () => {
  const [showAddOrderModal, setShowAddOrderModal] = useState(false);
  const [showNoteDrawer, setShowNoteDrawer] = useState(false);

  const handleCancelButtonClick = (orderId: string) => {
    console.log('Cancel orderId:', orderId);
    confirm({
      title: '確定取消育樂預約？',
      content: '取消後將無法復原',
      centered: true,
      onOk() {
        console.log('取消訂單');
        // TODO: 邏輯待寫
      },
    });
  };

  const handleEditNoteButtonClick = (orderId: string) => {
    console.log('Edit note orderId', orderId);
    // TODO: 邏輯待寫
    setShowNoteDrawer(true);
  };

  const closeNoteDrawer = () => {
    setShowNoteDrawer(false);
  };

  const columns = getOrderTableColumns(
    handleCancelButtonClick,
    handleEditNoteButtonClick
  );

  return (
    <>
      <Space direction="vertical" size="middle" className={styles.container}>
        <Space direction="vertical">
          <Button onClick={() => setShowAddOrderModal(true)}>新增預約</Button>
          <Filters />
        </Space>

        <Tabs
          items={[
            {
              label: '報名名單',
              key: '報名名單',
              children: (
                <Card>
                  <Table
                    bordered
                    rowKey="_id"
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={DUMMY_ORDER_LIST}
                  />
                </Card>
              ),
            },
          ]}
        />
      </Space>

      <NoteDrawer open={showNoteDrawer} closeDrawer={closeNoteDrawer} />

      <AddOrderModal
        open={showAddOrderModal}
        closeModal={() => setShowAddOrderModal(false)}
      />
    </>
  );
};
